<template>
  <ArvaModal
    name="executeInsetOrderModal"
    title="Execute Inset Supply Order"
    :wide="true"
    @close-modal="handleCloseModal"
  >
    <v-card class="pa-5">
      <form @submit.prevent="handleSubmit">
        <div>
          <h4>Requested Order Filters:</h4>

          <v-data-table
            v-if="previewDataFrame"
            :headers="headers"
            :items="previewDataFrame"
          ></v-data-table>

          <h4>Placeholder to have some contract work here</h4>

          <ArvaModalSaveFooter
            confirmText="Execute"
            cancelText="Cancel"
            @on-cancel="handleCloseModal"
            @on-confirm="handleSubmit"
          />
        </div>
      </form>
    </v-card>
  </ArvaModal>
</template>

<script>
import ArvaModal from "@/components/modals/ArvaModal"
import ArvaModalSaveFooter from "@/components/modals/ArvaModalSaveFooter"
import CarbonReadyAPI from "@/api/CarbonReadyAPI"

export default {
  name: "ExecuteInsetOrderModal",
  props: [
    "filterParams",
    "headers",
    "items",
    "currentOrderName",
    "currentOrderID",
  ],
  components: { ArvaModal, ArvaModalSaveFooter },

  data() {
    return {
      previewDataFrame: null,
      orderName: null,
      showError: false,
      orderPrice: 15,
      orderGeoids: [],
      supplyTarget: 10000,
    }
  },

  methods: {
    handleCloseModal() {
      this.$emit("close-modal")
    },
    handleSubmit() {
      if (this.currentOrderID != null) {
        let payload = { order_id: this.currentOrderID, status: "executed" }
        CarbonReadyAPI.updateInsetOrder(payload).then(response => {
          this.$emit("save-from-modal")
        })
      }
    },
  },
  mounted() {
    this.previewDataFrame = []
    for (const [key, value] of Object.entries(
      this.filterParams["filter_params"]
    )) {
      if (typeof value === "object" && value !== null) {
        this.previewDataFrame.push({
          category: key,
          value: JSON.stringify(value),
        })
      } else {
        this.previewDataFrame.push({ category: key, value: value })
      }
    }
  },
}
</script>

<style scoped>
.pw-error {
  color: red;
  font-weight: 500;
}
</style>
